// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStkstatawbtc } from "../../../icons/full/build/icon-stkstatawbtc.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StkstatawbtcIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStkstatawbtc.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StkstatawbtcIcon.displayName = 'StkstatawbtcIcon';
}

export default StkstatawbtcIcon;